import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaPinterest = props => {
  if (props.id !== "_svgsocialmediapinterest") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><g fill="#333"><path d="M120 15C62.562 15 16 61.562 16 119s46.562 104 104 104 104-46.562 104-104S177.438 15 120 15zm0 196c-50.729 0-92-41.271-92-92s41.271-92 92-92 92 41.271 92 92-41.271 92-92 92z" /><path d="M122.623 65c-30.565 0-45.975 21.914-45.975 40.188 0 11.064 4.188 20.91 13.173 24.578 1.473.603 2.792.021 3.221-1.61.296-1.13.999-3.978 1.314-5.162.431-1.614.263-2.179-.926-3.586-2.591-3.057-4.247-7.013-4.247-12.616 0-16.256 12.165-30.811 31.674-30.811 17.274 0 26.77 10.556 26.77 24.652 0 18.549-8.211 34.205-20.398 34.205-6.729 0-11.767-5.565-10.152-12.394 1.935-8.148 5.68-16.943 5.68-22.826 0-5.266-2.827-9.657-8.676-9.657-6.88 0-12.407 7.117-12.407 16.651 0 6.071 2.052 10.18 2.052 10.18l-8.274 35.054c-2.459 10.405-.371 23.16-.194 24.448.104.764 1.085.943 1.528.367.636-.827 8.83-10.943 11.615-21.053.788-2.86 4.526-17.683 4.526-17.683 2.235 4.263 8.768 8.019 15.715 8.019 20.678 0 34.711-18.854 34.711-44.089C163.352 82.771 147.186 65 122.623 65z" /></g></svg>;
};

SvgSocialmediaPinterest.displayName = "_svgsocialmediapinterest";
SvgSocialmediaPinterest.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaPinterest.defaultProps = {
  id: ''
};
export default SvgSocialmediaPinterest;